// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"da59833f","703":"844a098b"}[chunkId] + ".chunk.js";
};